import {
  FootballPlayerWithGradesTeamAndDraftInfo,
  getLeagueAbbreviation,
  LeagueID,
  PlayerCareer,
  PlayerLeague,
} from '@pff-consumer/schema'

export const addActiveSeasonsForRookie = (career: PlayerCareer, player: FootballPlayerWithGradesTeamAndDraftInfo) => {
  // we assume a player is a rookie if their last active season is in the NCAA and they have a different leagueId
  // if player is a rookie, we add a fake activeSeason to the player data
  // once their first non-NCAA season gets added to activeSeasons, isRookie will become false
  const lastSeason = career.activeSeasons[0]
  const isRookie = lastSeason.league.toLowerCase() === PlayerLeague.NCAA && player.leagueId !== LeagueID.CollegeFootball

  if (isRookie && !!player.leagueId) {
    const updatedCareer = { ...career }
    const rookieSeason = {
      ...lastSeason,
      league: getLeagueAbbreviation(player.leagueId) || PlayerLeague.NFL, // we should never have null here because we check for leagueId above
      position: player?.position,
      season: lastSeason.season,
      secondaryPosition: player?.position || null,
      team: player?.team,
      effectiveEnd: '3000-12-31',
    }
    updatedCareer.activeSeasons = [rookieSeason, ...career.activeSeasons]
    const { team } = player
    updatedCareer.teams = [
      {
        teamId: team.id,
        playerId: player.playerId,
        yearLabel: `${lastSeason.season} - Present`,
        teamLabel: `${team.city} ${team.name}`,
        teamAbbreviation: team.abbreviation,
        tvAbbreviation: team.tvAbbreviation,
        start: lastSeason.season,
        end: lastSeason.season + 1,
        league: getLeagueAbbreviation(player.leagueId) || PlayerLeague.NFL, // we should never have null here because we check for leagueId above
      },
      ...career.teams,
    ]
    return updatedCareer
  }

  return career
}
